import Vue from 'vue'

export default {
    timeout(){
        Vue.prototype.$toast("系统繁忙，请您稍后再试...",3000);
    }
}


// WEBPACK FOOTER //
// ./src/common/js/timeout.js